/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LinkExternalSmallIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAp0lEQVR4nO2TwQrCMAyGp+8w0TcKQpv0EBrQd+m7KR69ONHHmRQvKtOlWzxtP/RS0u9LIK2qOdOOIzl5klZ1MB6LBfmRWkDSmk4HzLWjePmLAJhrj9I8wfFqKoDXzjHeQ9htzATQAc/3JgL4AjcRwA/4aAH0wEcJPuFb5nVX3SCBFj5I8LbnKE0I+1Xfj3ckBy1/4VHOWnhxUkpLh3LLkjxJOWHO5PIAdtSp4KYji10AAAAASUVORK5CYII=)
 */
export const LinkExternalSmallIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8 5a1 1 0 0 0 0 2h7.59L5.29 17.3a1 1 0 1 0 1.42 1.4L17 8.42V16a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1H8Z"
        className={colorClass}
      />
    </svg>
  );
};
